import React from 'react';
import { NodeProps } from '@xyflow/react';
import useLocale from 'next-translate/useTranslation';
import TextareaAutosize from 'react-textarea-autosize';
import { BaseNode, createOutputHandle } from './BaseNode';
import { useWorkflowStore } from '@/lib/workflows/store';
import { NodeExecutionStatus } from 'types';

interface InputNodeProps extends NodeProps {
  nodeId?: string;
  readOnly?: boolean;
}

export function InputNode({
  id,
  data,
  selected,
  nodeId,
  readOnly,
}: InputNodeProps) {
  const { t } = useLocale('common');
  const updateNodeData = useWorkflowStore((state) => state.updateNodeData);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    e.stopPropagation();
    updateNodeData(id, {
      config: {
        ...(data.config || {}),
        value: e.target.value,
      },
      result: e.target.value,
    });
  };

  return (
    <div className='w-[380px]'>
      <BaseNode
        title={(data.label as string) || t('Input')}
        icon={
          <svg
            className='w-4 h-4 text-gray-600'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path d='M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z' />
          </svg>
        }
        hasInput={false}
        hasOutput={false}
        status={data.status as NodeExecutionStatus | undefined}
        selected={selected}
        nodeId={nodeId || id}
        readOnly={readOnly}
        disableMinWidth={true}
        customOutputs={createOutputHandle('text', 'text', 50)}
      >
        <div className='space-y-2 px-4 py-3 pt-5'>
          <TextareaAutosize
            value={(data.config as { value?: string })?.value || ''}
            onChange={handleChange}
            placeholder={t('Enter your input here...')}
            className='nodrag w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-500 focus:border-transparent resize-none dark:border-white/5 dark:bg-slate-700/50 dark:text-white overflow-y-auto'
            disabled={readOnly}
            minRows={5}
            onWheel={(e) => e.stopPropagation()}
          />
        </div>
      </BaseNode>
    </div>
  );
}
